export const labels = {
  area: "Perimeter length",
  longitude: "Lon",
  latitude: "Lat",
};
